import { ReasoningStepType } from "@f2e/shared/types";
export function getReasoningStepTypeLabels(t) {
    const labels = {
        [ReasoningStepType.ConsultantSearchWeb]: t("chat.reasoningSteps.searchWeb", "Search Web"),
        [ReasoningStepType.ConsultantFetchWebContent]: t("chat.reasoningSteps.fetchWebContent", "Fetch Web Content"),
        [ReasoningStepType.ConsultantRetrieveContextObjs]: t("chat.reasoningSteps.retrieveContextObjs", "Retrieve Knowledge Base"),
        [ReasoningStepType.ConsultantGetContextObjLines]: t("chat.reasoningSteps.getContextObjLines", "Get Knowledge Base Lines"),
        [ReasoningStepType.ConsultantListKbFiles]: t("chat.reasoningSteps.listKbFiles", "List Knowledge Base Files"),
        [ReasoningStepType.ConsultantCallAgent]: t("chat.reasoningSteps.callAgent", "Call Agent"),
        [ReasoningStepType.ConsultantMemory]: t("chat.reasoningSteps.memory", "Save Memory"),
        [ReasoningStepType.ConsultantGenerateImage]: t("chat.reasoningSteps.generateImage", "Generate Image"),
        [ReasoningStepType.ConsultantHttpRequest]: t("chat.reasoningSteps.httpRequest", "HTTP Request"),
        [ReasoningStepType.ConsultantTabularQuery]: t("chat.reasoningSteps.tabularQuery", "Query Table"),
        [ReasoningStepType.ConsultantAnalyzeHistories]: t("chat.reasoningSteps.analyzeHistories", "Analyze conversation history"),
        [ReasoningStepType.ConsultantLookup]: t("chat.reasoningSteps.lookup", "Lookup"),
        // Backward-compat
        [ReasoningStepType.ConsultantLookupAgent]: t("chat.reasoningSteps.lookupAgent", t("chat.reasoningSteps.lookup", "Lookup")),
        [ReasoningStepType.ConsultantRequestForm]: t("chat.reasoningSteps.requestForm", "Request Form"),
        [ReasoningStepType.ConsultantFinished]: t("chat.reasoningSteps.finished", "Finished"),
    };
    return labels;
}
//# sourceMappingURL=reasoningStepLabels.js.map